<script>
	import { block_special_characters, validate } from "$misc/actions";
import code from "$stores/code";
	import { createEventDispatcher, onMount } from "svelte";

	export let value = "";
	export let required = true;
	export let block = true;

	export const trigger = () => {
		const node = document.querySelector(`#cellphone_number`);
		node.focus();
		node.blur();
	};

	const enhance = (node) => {
		const iti = intlTelInput(node, {
			async geoIpLookup(success) {
				try {
					jQuery
						.get("https://ipinfo.io", () => {}, "jsonp")
						.always((r) => {
							success(r && (r.country ?? "ZA"));
						});
				} catch (error) {
					console.log("error:", error);
				}
			},
			hiddenInput: `cellphone_number_full`,
			utilsScript: "/scripts/intlTel_utils.js",
			initialCountry: "auto",
			autoPlaceholder: false,
			formatOnDisplay: false,
			separateDialCode: true,
		});

		const update = () => {
			node.dispatchEvent(new Event("input"));
		};

		block && block_special_characters(node);
		validate(node, "cellphone");

		node.addEventListener("countrychange", update);

		return {
			destroy() {
				iti.destroy();
				node.removeEventListener("countrychange", update);
			},
		};
	};

	const dispatch = createEventDispatcher();

	const send_validation_state = (node) => {
		const parent = node.parentElement;

		const check = () => {
			const valid = node.validity.valid;
			const valid_size = node.value.trim().length >= node.minLength;
			const flagged = parent.classList.contains("field--invalid");
			return valid && valid_size && !flagged;
		};

		const send = () => {
			const full = document.querySelector(".iti__selected-dial-code");
			const code = full.textContent.trim();
			setTimeout(() => dispatch("validate", { code, valid: check() }), 100);
		};

		node.addEventListener("input", send);
		node.addEventListener("change", send);

		if (value) {
			node.dispatchEvent(new Event("change"));
		}

		return {
			destroy() {
				node.removeEventListener("input", send);
				node.removeEventListener("change", send);
			},
		};
	};
</script>

<div class="form-group">
	<label for="cellphone_number">Cellphone</label>

	<div class="phone-field-container" style="width: 100% !important">
		<input
			use:enhance
			use:send_validation_state
			class="form-control"
			id="cellphone_number"
			name="cellphone_number"
			type="tel"
			placeholder="Cellphone"
			style="padding-left: 80px !important"
			maxlength="16"
			minlength="7"
			{value}
			{required}
		/>
	</div>
</div>

<style lang="scss" :global>
	input.form-control {
		padding-left: 6.75em !important;
	}
	.phone-field-container :global(.iti) {
		display: block;
	}
	.phone-field-container :global(.iti__selected-dial-code),
	:global(#country-listbox .iti__country) {
		font-size: 0.8rem;

		@media only screen and (max-width: 768px) {
			font-size: 1.25rem;
		}

		@media only screen and (max-width: 575px) {
			font-size: 2rem;
		}
	}

	:global(.iti__selected-flag:focus) {
		outline: solid 0.1em var(--qualimi-yellow);
		box-shadow: 0 0 0 0.2em var(--qualimi-yellow);
	}
</style>
